export default "__VITE_ASSET__DGjyKIbv__"